import { bgColor, focusVisible, hoverBgColor } from "../../Resources/CSS/styling"

export const Button = ({ children, className, onClick, disabled }) => {

    const classNamesContainsColor = className?.includes('bg-');
    const classNamesContainsTextColor = className?.includes('text-');
    return (
        <button
            type="button"
            className={`rounded-md ${!classNamesContainsColor ? bgColor : ''} px-3 py-2 text-sm font-semibold ${!classNamesContainsTextColor ? 'text-white' : ''} shadow-sm ${disabled ? 'opacity-50' : !classNamesContainsColor ? hoverBgColor : ''} focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${!classNamesContainsColor ? focusVisible : ''} ${className}`}
            onClick={onClick}
            disabled={disabled}
        >
            {children}
        </button>
    )
}